/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  Constants  */
const { hasData, getOne, getCount, getData } = Response;

class UserApp {
    constructor() {
        this.requests = new Requests();
    }

    cancel = () => {
        this.requests.cancel();
    };

    getOne = async (params = {}) => {
        try {
            const response = await axios.get('/userApp', {
                cancelToken: this.requests.token(),
                params
            });

            if (!hasData(response)) {
                return false;
            }

            return getOne(response);
        } catch (e) {
            debug.e('Unable to get User App', e);
            return false;
        }
    };

    getAll = async (p = {}) => {
        const params = { ...p, size: -1 };

        try {
            const response = await axios.get('/userApp', {
                cancelToken: this.requests.token(),
                params
            });

            if (!hasData(response)) {
                return [];
            }

            return getData(response);
        } catch (e) {
            debug.e('Unable to get User Apps', e);
            return [];
        }
    };

    getCount = async (p = {}) => {
        const params = { ...p, count: true };

        try {
            const response = await axios.get('/userApp', {
                cancelToken: this.requests.token(),
                params
            });

            return getCount(response);
        } catch (e) {
            debug.e('Unable to get User App Count', e);
            return [];
        }
    };
}

export default UserApp;
